import React, { useState, useCallback, useEffect, useRef } from "react";
import { connect } from "react-redux";
import "../../../../css/salesorder.css";
import { GridLayout } from "../../../../../common/GridLayout";
import {
    Column,
    DataGrid,
    GroupPanel,
    Scrolling,
    Grouping,
    FilterRow,
    HeaderFilter,
    FilterPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar,
    Item,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
    ColumnHeaderFilter,
} from "devextreme-react/data-grid";
import GridLayoutManager from "../../../../../gridLayoutCustomization/GridLayoutManager";
const stages = [{ ID: "A", Text: "Assigned - Effect Available" }, { ID: "C", Text: "Shipped/Completed" }
    , { ID: "F", Text: "Future - No Effect On Net Available" }, { ID: "L", Text: "Canceled" }
    , { ID: "N", Text: "Pending - Effects Net Available" }, { ID: "P", Text: "Plan - No Inventory Effect" }
    , { ID: "Q", Text: "Quote - No Inventory Effect" }, { ID: "S", Text: "Picked/Staged - Effect Available" }, { ID: "Put Away/Completed", Text: "Put Away/Completed" }];
var status = [{ ID: "O", Text: "Open" }, { ID: "H", Text: "Hold" },
{ ID: "R", Text: "Received" }, { ID: "Z", Text: "Committed" }, { ID: "L", Text: "Ready To Commit Later" }];

const AllTransactionTabResult = (props) => {
    const dataGrid = useRef(null);
    var accessToken = props.oidc.user.access_token;
    const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
    const gridKey = "3827e4c7-93df-4173-bc07-cc2dee2921ff";
       const [currentLayout, setCurrentLayout]= useState("Default");
    const saveState = useCallback((state) => {GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
    
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
    const onRowPrepared = (e) => {
        if (e.rowType === 'data') {
            if (e.data.transactionType === 'C') {
                e.rowElement.style.backgroundColor = '#FFCDD2'; // Light red for Inactive
            }
        }
    };
    return (
        <div>
            <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
             ref={dataGrid}
                dataSource={props.data}
                allowColumnReordering={true}
                allowColumnResizing={true}
                showBorders={true}
                hoverStateEnabled={true}
                className="SearchOrderSalesResultOpenState"
                searchExpr="status"
                remoteOperations={true}
                searchEnabled={true}
                columnAutoWidth={true}
                onRowPrepared={onRowPrepared}
            >
                <ColumnChooser
                    enabled={true}
                    title="Choose Column"
                    width={290}
                    height={290}
                    sortOrder="asc"
                >
                    <ColumnChooserSearch
                        enabled={true}
                        editorOptions={{ placeholder: 'Search column' }} />
                </ColumnChooser>
                <Export enabled={true} allowExportSelectedData={true} />
                <Selection mode="none" />
                <Sorting visible={true} mode="multiple" />
                <Paging defaultPageSize={10} />
                <Pager
                    visible={true}
                    showPageSizeSelector={true}
                    allowedPageSizes={allowedPageSizes}
                    showNavigationButtons={true}
                />
                <FilterRow visible={true} />
                <FilterPanel visible={true} />
                <GroupPanel visible={true} />
                <Grouping autoExpandAll={false} />
                <StateStoring
                    enabled={true}
                    type="custom"
                    customLoad={loadState}
                    storageKey={gridKey}
                    customSave={saveState}
                />
                <FilterRow visible={true} />
                <Column dataField="program" caption='Program' ></Column>
                <Column dataField="module" caption='Module' ></Column>
                <Column dataField="transactionType" caption='Transaction Type'
                    calculateCellValue={(rowData) => {
                        const program = rowData.program ? rowData.program.toUpperCase() : '';
                        const transactionType = rowData.transactionType;

                        if (program === 'PO RECEIPTS') {
                            switch (transactionType) {
                                case 'R': return 'Receipt/Invoice';
                                case 'C': return 'Credit/Return';
                                case 'D': return 'Adjustment';
                                case 'P': return 'Receiving Plan';
                                default: return '';
                            }
                        } else if (program === 'IM TRANSACTION') {
                            switch (transactionType) {
                                case 'U': return 'Usage';
                                case 'R': return 'Usage Return';
                                case 'L': return 'Usage Allowance';
                                case 'A': return 'Adjustment';
                                case 'C': return 'Receipt';
                                case 'T': return 'Receipt Return';
                                case 'W': return 'Receipt Allowance';
                                case 'M': return 'Damaged/Unavailable';
                                default: return '';
                            }
                        } else if (program === 'OM TRANSACTION') {
                            switch (transactionType) {
                                case 'I': return 'Order/Invoice';
                                case 'C': return 'Credit';
                                case 'J': return '$ Adjustment';
                                default: return '';
                            }
                        } else if (program === 'AR CASH RECEIPTS') {
                            switch (transactionType) {
                                case 'I': return 'Invoice';
                                case 'C': return 'Credit';
                                case 'A': return 'Adjustment';
                                case 'F': return 'Finance Charge';
                                case 'M': return 'Deposit memo';
                                default: return '';
                            }
                        } else {
                            return ''; // Default case if no match is found
                        }
                    }} ></Column>
                <Column dataField="transactionNumber" caption='Transaction #' ></Column>
                <Column dataField="transactionDate" caption='Transaction Date' dataType="date" ></Column>
                <Column dataField="reference" caption='Reference' ></Column>
                <Column dataField="quantity" dataType="number" caption='Quantity' format={{
                    type: 'fixedPoint',
                    precision: 2,
                    useGrouping: true
                }}></Column>
                <Column dataField="price" caption='Price' dataType="number"
                    format={{
                        type: 'currency',
                        precision: 2,
                        currency: 'USD',
                        useGrouping: true
                    }} ></Column>
                <Column dataField="amount" caption='Amount' dataType="number"
                    format={{
                        type: 'currency',
                        precision: 2,
                        currency: 'USD',
                        useGrouping: true
                    }} ></Column>

                <Column dataField="invoiceDate" caption="Invoice Date" dataType="date" visible={false}></Column>
                <Column dataField="description" caption="Description" visible={false}></Column>
                <Column dataField="stage" caption="Stage" visible={false}
                    lookup={{ dataSource: stages, valueExpr: 'ID', displayExpr: 'Text' }} 
                    cellRender={cellData => {
                        switch (cellData.value) {
                            case 'A':
                                return <span>Assigned - Effect Available</span>;
                            case 'C':
                                return <span>Shipped/Completed</span>;
                            case 'F':
                                return <span>Future - No Effect On Net Available</span>;
                            case 'L':
                                return <span>Canceled</span>;
                            case 'N':
                                return <span>Pending - Effects Net Available</span>;
                            case 'P':
                                return <span>Plan - No Inventory Effect</span>;
                            case 'Q':
                                return <span>Quote - No Inventory Effect</span>;
                            case 'S':
                                return <span>Picked/Staged - Effect Available</span>;
                            default:
                                return <span>{cellData.value}</span>;
                        }
                    }}></Column>
                <Column dataField="status" caption="Status" visible={false}
                    lookup={{ dataSource: status, valueExpr: 'ID', displayExpr: 'Text' }} cellRender={cellData => {
                        switch (cellData.value) {
                            case 'O':
                                return <span>Open</span>;
                            case 'H':
                                return <span>Hold</span>;
                            case 'L':
                                return <span>Ready To Commit Later</span>;
                            case 'R':
                                return <span>Received</span>;
                            case 'Z':
                                return <span>Committed</span>;
                            default:
                                return <span>{cellData.value}</span>;
                        }
                    }}></Column>
                <Column dataField="headerdiscountamount" caption="Header Discount Amount" visible={false}></Column>
                <Column dataField="headercode1" caption="Header Code 1" visible={false}></Column>
                <Column dataField="headercode2" caption="Header Code 2" visible={false}></Column>
                <Column dataField="headercode3" caption="Header Code 3" visible={false}></Column>
                <Column dataField="headercode4" caption="Header Code 4" visible={false}></Column>
                <Column dataField="headercode5" caption="Header Code 5" visible={false}></Column>
                <Column dataField="headercode6" caption="Header Code 6" visible={false}></Column>
                <Column dataField="headercode7" caption="Header Code 7" visible={false}></Column>
                <Column dataField="headercode8" caption="Header Code 8" visible={false}></Column>
                <Column dataField="headercode9" caption="Header Code 9" visible={false}></Column>
                <Column dataField="headercode10" caption="Header Code 10" visible={false}></Column>
                <Column dataField="headerdate1" caption="Header Date 1" dataType="date" visible={false}></Column>
                <Column dataField="headerdate2" caption="Header Date 2" dataType="date" visible={false}></Column>
                <Column dataField="headerdate3" caption="Header Date 3" dataType="date" visible={false}></Column>
                <Column dataField="headerdate4" caption="Header Date 4" dataType="date" visible={false}></Column>
                <Column dataField="headerdate5" caption="Header Date 5" dataType="date" visible={false}></Column>
                <Column dataField="headerdate6" caption="Header Date 6" dataType="date" visible={false}></Column>
                <Column dataField="headerdate7" caption="Header Date 7" dataType="date" visible={false}></Column>
                <Column dataField="headerdate8" caption="Header Date 8" dataType="date" visible={false}></Column>
                <Column dataField="headerdate9" caption="Header Date 9" dataType="date" visible={false}></Column>
                <Column dataField="headerdate10" caption="Header Date 10" dataType="date" visible={false}></Column>
                <Column dataField="headerquantity1" caption="Header Quantity 1" visible={false}></Column>
                <Column dataField="headerquantity2" caption="Header Quantity 2" visible={false}></Column>
                <Column dataField="headerquantity3" caption="Header Quantity 3" visible={false}></Column>
                <Column dataField="headerquantity4" caption="Header Quantity 4" visible={false}></Column>
                <Column dataField="headerquantity5" caption="Header Quantity 5" visible={false}></Column>
                <Column dataField="headerquantity6" caption="Header Quantity 6" visible={false}></Column>
                <Column dataField="headerquantity7" caption="Header Quantity 7" visible={false}></Column>
                <Column dataField="headerquantity8" caption="Header Quantity 8" visible={false}></Column>
                <Column dataField="headerquantity9" caption="Header Quantity 9" visible={false}></Column>
                <Column dataField="headerquantity10" caption="Header Quantity 10" visible={false}></Column>
                <Column dataField="headerreference1" caption="Header Reference 1" visible={false}></Column>
                <Column dataField="headerreference2" caption="Header Reference 2" visible={false}></Column>
                <Column dataField="headerreference3" caption="Header Reference 3" visible={false}></Column>
                <Column dataField="headerreference4" caption="Header Reference 4" visible={false}></Column>
                <Column dataField="headerreference5" caption="Header Reference 5" visible={false}></Column>
                <Column dataField="headerreference6" caption="Header Reference 6" visible={false}></Column>
                <Column dataField="headerreference7" caption="Header Reference 7" visible={false}></Column>
                <Column dataField="headerreference8" caption="Header Reference 8" visible={false}></Column>
                <Column dataField="headerreference9" caption="Header Reference 9" visible={false}></Column>
                <Column dataField="headerreference10" caption="Header Reference 10" visible={false}></Column>
                <Column dataField="transcurrencytype" caption="Trans Currency Type" visible={false}></Column>
                <Column dataField="paycurrencytype" caption="Pay Currency Type" visible={false}></Column>
                <Column dataField="ratetiming" caption="Rate Timing" visible={false}></Column>
                <Column dataField="currencyrate" caption="Currency Rate" visible={false}></Column>
                <Column dataField="datereceived" caption="Date Received" visible={false}></Column>
                <Column dataField="orderedQuantity" caption="Ordered Quantity" visible={false}></Column>
                <Column dataField="quantity" caption="Quantity" visible={false}></Column>
                <Column dataField="discountedPrice" caption="Discounted Price" visible={false}></Column>
                <Column dataField="foreignPrice" caption="Foreign Price" visible={false}></Column>
                <Column dataField="foreignAmount" caption="Foreign Amount" visible={false}></Column>
                <Column dataField="discountedForeignPrice" caption="Discounted Foreign Price" visible={false}></Column>
                <Column dataField="detailcode1" caption="Detail Code 1" visible={false}></Column>
                <Column dataField="detailcode2" caption="Detail Code 2" visible={false}></Column>
                <Column dataField="detailcode3" caption="Detail Code 3" visible={false}></Column>
                <Column dataField="detailcode4" caption="Detail Code 4" visible={false}></Column>
                <Column dataField="detailcode5" caption="Detail Code 5" visible={false}></Column>
                <Column dataField="detaildate1" caption="Detail Date 1" dataType="date" visible={false}></Column>
                <Column dataField="detaildate2" caption="Detail Date 2" dataType="date" visible={false}></Column>
                <Column dataField="detaildate3" caption="Detail Date 3" dataType="date" visible={false}></Column>
                <Column dataField="detaildate4" caption="Detail Date 4" dataType="date" visible={false}></Column>
                <Column dataField="detaildate5" caption="Detail Date 5" dataType="date" visible={false}></Column>
                <Column dataField="detailquantity1" caption="Detail Quantity 1" visible={false}></Column>
                <Column dataField="detailquantity2" caption="Detail Quantity 2" visible={false}></Column>
                <Column dataField="detailquantity3" caption="Detail Quantity 3" visible={false}></Column>
                <Column dataField="detailquantity4" caption="Detail Quantity 4" visible={false}></Column>
                <Column dataField="detailquantity5" caption="Detail Quantity 5" visible={false}></Column>
                <Column dataField="detailreference1" caption="Detail Reference 1" visible={false}></Column>
                <Column dataField="detailreference2" caption="Detail Reference 2" visible={false}></Column>
                <Column dataField="detailreference3" caption="Detail Reference 3" visible={false}></Column>
                <Column dataField="detailreference4" caption="Detail Reference 4" visible={false}></Column>
                <Column dataField="detailreference5" caption="Detail Reference 5" visible={false}></Column>
                <Column dataField="lastUpdateDateTime" caption="Last Update DateTime" dataType="date" visible={false}></Column>
                <Column dataField="lastUpdateUserId" caption="Last Update User ID" visible={false}></Column>
                <Column dataField="creationDateTime" caption="Creation DateTime" dataType="date" visible={false}></Column>
                <Column dataField="creationUserId" caption="Creation User ID" visible={false}></Column>
                <Column dataField="commitdate" caption="Commit Date" dataType="date" visible={false}></Column>
                <Column dataField="fiscalperiod" caption="Fiscal Period" visible={false}></Column>
                <Column dataField="fiscalyear" caption="Fiscal Year" visible={false}></Column>
                <Column dataField="detailrowid" caption="Detail Row ID" visible={false}></Column>

                <Toolbar>
                <Item location="after">
                        <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                    </Item>
                    <Item name="exportButton" />
                    <Item name="columnChooserButton" />
                </Toolbar>
            </DataGrid>
        </div>
    )
};
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(AllTransactionTabResult);